module.exports = Framework7Vue;


//////////////////
// WEBPACK FOOTER
// external "Framework7Vue"
// module id = sz+0
// module chunks = 252